export default "__VITE_ASSET__mMZVnlCu__"